module.exports = __webpack_public_path__ + "img/PopDenseMiningCroppingSystem_2.a1cda5ec.jpg";